import { LoyaltyEngineReward, LoyaltyReward } from 'state/loyalty/types';
import noop from 'utils/noop';

export type IEngineRewardsMap = {
  [rewardId: string]: LoyaltyEngineReward;
};
export type ISanityRewardsMap = Record<LoyaltyReward['_id'], LoyaltyReward>;

export const useLoyaltyRewardsList = () => {
  return {
    rewards: null,
    loading: false,
    engineRewardsMap: {} as IEngineRewardsMap,
    sanityRewardsMap: {} as ISanityRewardsMap,
    refetchRewards: noop,
  };
};
